import { useCallback, useState } from "react";
import { ButtonDef } from "../core/form/ButtonDef";
import { useChannel } from "../core/hooks/useChannel";
import { ConditionalController } from "../core/hooks/useConditional";
import { AllContent, Section, SubReport, TOC } from "../core/pdf/types";
import { Icon } from "../core/ui/icons";
import { pasteHtmlAtCaret } from "../core/utils/html";
import { DesignerMessages } from "./types";
import { useDesigner } from "./useDesigner";
import { ElementState } from "./useElementContext";
import { closestIndex } from "../core/utils/dom";

export function Toolbox(props: {

}) {

	const designer = useDesigner();

	const [focused, setFocused] = useState<AllContent | undefined>();
	const [, refresh] = useState({});

	useChannel(designer.channel, useCallback((msg) => {

		if (msg.type === DesignerMessages.FOCUS_CHANGED) {
			setFocused(designer.focus);

		} else if (msg.type === DesignerMessages.FOCUS_REFRESH) {
			// forcing refresh
			refresh({});

		}

	}, []));


	let elementContext: ElementState | undefined;
	if (focused) {
		elementContext = designer.getContext(focused.id!);
	}

	let toRefresh: any;
	let contentArray: any;
	if (focused) {
		const f = focused as any;
		if (f.content) {
			contentArray = f.content;
			toRefresh = f;
		} else {
			// see if parent of what has the focus has content[]
			const context = designer.getContext(focused.id!);
			if (context) {
				const p = context.parent.def as any;
				if (p && p.content) {
					contentArray = p.content;
					toRefresh = p;
				}
			}
		}
	}

	const options: ButtonDef[] = [];

	if (contentArray) {
		options.push(
			{ title: "Paragraph", id: "p", icon: "paragraph" },
			{ title: "Page Break", id: "pagebreak", icon: "pageBreak" },
			{ title: "List", id: "list", icon: "list" },
			{ title: "Table", id: "table", icon: "table" },
			{ title: "Group", id: "group", icon: "group" },
			{ title: "Image", id: "image", icon: "image" },
			{ title: "Sub Report", id: "sub-report", icon: "document" },
			{ title: "Signature Block", id: "sig-block", icon: "signature" },
			{ title: "Tag", id: "tag", icon: "tag" },
			{ title: "Link", id: "link", icon: "link" },
		);
	}

	if (focused && (focused.type === "p" || focused.type === "heading")) {
		options.push(
			{ title: "Field", id: "field", icon: "field" },
		);
	}

	if (focused && (focused.type === "section")) {
		options.push(
			{ title: "Table of Contents", id: "toc", icon: "toc" },
		);
	}

	function handleMouseDown(e: any) {
		if (!focused) return;

		const index = closestIndex(e.target, ".item");
		if (index < 0) return;

		const option = options[index];

		const type = option.id!;

		if (type === "field") {
			const name = "field";
			pasteHtmlAtCaret(
				`<span
					class="field-token"
					contentEditable="false"
					id="${designer.nextID()}"
					data-options='${encodeURIComponent(JSON.stringify({}))}'
				>${name}</span>
				`,
			);

			// force a change event
			designer.broadcastToContent(focused.id!, {
				type: DesignerMessages.CHANGED,
			})

		
		} else if (focused && (focused.type === "section") && type === "sub-report") {
			const obj = designer.createItem("sub-report") as SubReport;
			const i = designer.structure.sections.indexOf(focused as any);
			designer.structure.sections.splice(i+1, 0, obj as any);

			designer.setFocus(obj);
			designer.refreshRoot();

		} else if (type === "toc") {
			const obj = designer.createItem("toc") as TOC;
			const s = focused as Section;
			s.content.push(obj);

			designer.refreshRoot();

		} else {
			const obj = designer.createItem(type);
			const currentIndex = contentArray.indexOf(focused);
			if (currentIndex >= 0) {
				let i = currentIndex;
				if (!e.shiftKey) i++;
				contentArray.splice(i, 0, obj);
			} else {
				if (e.shiftKey) {
					contentArray.splice(0, 0, obj);
				} else {
					contentArray.push(obj);
				}
			}

			designer.setFocus(obj);
			designer.refreshItem(toRefresh);

		}

		e.preventDefault();
		return false;
	}

	let icons = [];
	let i = 0;
	for(let o of options) {
		icons.push(
			<div className="item" data-index={i} >
				<Icon type={o.icon as any} size="normal" />
				<div>{o.title}</div>
			</div>
		);
		i++;
	}

	return (
		<div
			className="toolbox text-inverse"
			onMouseDown={handleMouseDown}
		>
			{icons}
		</div>
	)
}